import GlobalSearch from "./global-search/GlobalSearch.vue";


export default {
    'global-search': GlobalSearch,
};